import React from "react";
import { Row } from "antd";
import { Typography, Button } from "../core";

const DeleteSizerRate = () => {
  return (
    <div>
      <Typography as="h2" color="#F04633" weight="800" align="center">
        Are you sure you want to delete this ?
      </Typography>
      <Row type="flex" justify="space-around">
        <div>
          <Typography as="h3" color="#404E67" weight="bold">
            Quality
          </Typography>
          <Typography align="center" as="h6" color="#979BA4" weight="500">
            Khadii
          </Typography>
        </div>
        <div>
          <Typography as="h3" color="#404E67" weight="bold">
            Rate/Rs
          </Typography>
          <Typography align="center" as="h6" color="#979BA4" weight="500">
            7899
          </Typography>
        </div>
      </Row>
      <Row type="flex" justify="space-around">
        <Button
          width="187px"
          height="55px"
          border="4px solid #F04633"
          bg="white"
          margin="10px auto"
        >
          <Typography
            as="h3"
            noMargin
            align="center"
            color="#F04633"
            weight="bold"
          >
            Yes
          </Typography>
        </Button>
        <Button width="187px" height="55px" bg="#F04633" margin="10px auto">
          <Typography
            as="h3"
            color="white"
            noMargin
            align="center"
            weight="bold"
          >
            No
          </Typography>
        </Button>
      </Row>
    </div>
  );
};

export default DeleteSizerRate;
